(function($) { 
    $(document).foundation();
})(jQuery);